import React, { Component } from 'react'
import { IconButton, InputAdornment, Dialog } from '@material-ui/core'
import { Square } from 'mdi-material-ui'
import { ChromePicker } from 'react-color'

export default class ColorPicker extends Component {
  state = {
    displayColorPicker: false,
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }

  render() {
    return (
      <>
        <InputAdornment position="end">
          <IconButton
            aria-label="Toggle password visibility"
            onClick={this.handleClick}
            style={{
              color: this.props.value,
              borderRadius: 0,
              border: 'solid rgba(0, 0, 0, 0.23) 1px',
              padding: 1,
            }}
          >
            <Square />
          </IconButton>
            <Dialog open={this.state.displayColorPicker} onClose={this.handleClose}>
              <ChromePicker
                color={this.props.value}
                onChangeComplete={color =>
                  this.props.handleFormValueChange(color.hex)
                }
              />
            </Dialog>
        </InputAdornment>
      </>
    )
  }
}
